export default __webpack_public_path__ + "static/media/warning--winding-road-first-right--g4.0c7093c2.png";